import Icon from "../../../../components/base/Icon";
import ToolTip from "../../../../components/base/ToolTip";
import { Job } from "../models/Job";


/** The colour of the badge; fixed, since it is not one of the account's own flags. */
export const PER_CALL_DUPLICATE_COLOR = "#f6a609";

interface IProps {
    job?: Job
    /** "badge" next to the job's flags (default), "dot" for the board row's round flag icons. */
    variant?: "badge" | "dot"
    fontSize?: number
    className?: string
}

/**
 * "Per Call Duplicated": Percall sent this job while the account already had an open job with the
 * same phone, address and job type. Shown wherever the job's flags are, but it is not a Flag
 * record -- it comes from job.isPerCallDuplicate and cannot be removed like one.
 */
export default function PerCallDuplicateBadge(props: IProps) {

    if (!props.job?.isPerCallDuplicate) return <></>;

    const hint = (props.job.perCallDuplicateOf
        ? `Percall sent this job again while job #${props.job.perCallDuplicateOf} (same phone, address and job type) was still open.`
        : "Percall sent this job again while a job with the same phone, address and job type was still open.")
        + (props.job.perCallDuplicateOtherSource ? " That job came from a different job source." : "");

    if (props.variant === "dot") {
        return (
            <ToolTip content={<><b>Per Call Duplicated</b><div className="fs-8 mt-1">{hint}</div></>} maxWidth={260}>
                <span className={`job-dashboard-flag ms-1 ${props.className ?? ""}`} style={{ backgroundColor: PER_CALL_DUPLICATE_COLOR }}>
                    <Icon icon="clone" size={8} type="solid" />
                </span>
            </ToolTip>
        )
    }

    return (
        <ToolTip content={hint} maxWidth={260}>
            <span className={`badge me-1 ${props.className ?? ""}`}
                style={{ fontSize: props.fontSize, backgroundColor: PER_CALL_DUPLICATE_COLOR, color: "#fff" }}>
                <Icon icon="clone" size={10} type="solid" className="me-1" />
                Per Call Duplicated
            </span>
        </ToolTip>
    )
}
